import { NewTravelPolicyState, UpdateState } from "../../types/travel/Policy";
import {
  updateTravellersIsRequesterChange,
  updateTravellersOnAdultCount,
  updateTravellersOnChildCount,
  updateTravellersOnRequesterChange,
  updateTravellersType,
} from "./travellers";
import { set } from "lodash/fp";
import { defaultTravelPlan } from "./newTravelPolicyInitialization";

const travellerTypeSlice = ["policyType", "groupType", "adultCount", "childrenCount"];

// const getFamilyCount = (flowState: NewTravelPolicyState) => {
//   return flowState.travelDetails.adultCount + flowState.travelDetails.childrenCount;
// };

const resetPlanAndAddOn: UpdateState = (prevFlowState, key) => {
  if (key === "travelDetails") {
    return {
      ...prevFlowState,
      travelPlan: defaultTravelPlan,
    };
  }
  return prevFlowState;
};

const resetAdultAndChildrenCount: UpdateState = (prevFlowState, key, sliceKey) => {
  if (key === "travelDetails" && (sliceKey === "policyType" || sliceKey === "groupType")) {
    return {
      ...prevFlowState,
      travelDetails: {
        ...prevFlowState["travelDetails"],
        adultCount: 1,
        childrenCount: 0,
      },
    };
  }
  return prevFlowState;
};

const setTravellerType: UpdateState = (prevFlowState, key, sliceKey) => {
  const sliceKeys = travellerTypeSlice.indexOf(sliceKey as string);
  if (key === "travelDetails" && sliceKeys) {
    const travellerType = updateTravellersType(
      prevFlowState.travelDetails.groupType,
      prevFlowState.travelDetails.adultCount,
      prevFlowState.travelDetails.childrenCount
    );
    return {
      ...prevFlowState,
      travelDetails: {
        ...prevFlowState["travelDetails"],
        travellerType: travellerType,
      },
      personalDetails: {
        ...prevFlowState["personalDetails"],
        isTravellerTypeGroup: travellerType === "group",
      },
    };
  }
  return prevFlowState;
};

const setTravellers: UpdateState = (prevFlowState, key, sliceKey) => {
  let updatedFlowState = prevFlowState;
  const sliceKeys = travellerTypeSlice.indexOf(sliceKey as string);
  if (key === "travelDetails" && sliceKeys) {
    updatedFlowState = {
      ...prevFlowState,
      personalDetails: {
        ...prevFlowState["personalDetails"],
        requestingPersonIsTravelingPerson: prevFlowState.travelDetails.adultCount > 0,
        travellers: updateTravellersOnAdultCount(prevFlowState.travelDetails),
        childTravellers: updateTravellersOnChildCount(prevFlowState.travelDetails),
      },
    };
  }
  if (key === "personalDetails" && sliceKey === "requestingPersonIsTravelingPerson") {
    updatedFlowState = {
      ...prevFlowState,
      personalDetails: {
        ...prevFlowState["personalDetails"],
        travellers: updateTravellersIsRequesterChange(
          prevFlowState.personalDetails,
          prevFlowState.personalDetails.requestingPersonIsTravelingPerson,
          prevFlowState.personalDetails.travellers
        ),
      },
    };
  }
  const sliceMatch = sliceKey === "requester.fullName" || sliceKey === "requester.identificationNumber" || sliceKey === "requester.dateOfBirth";
  if (key === "personalDetails" && sliceMatch) {
    updatedFlowState = {
      ...prevFlowState,
      personalDetails: {
        ...prevFlowState["personalDetails"],
        travellers: updateTravellersOnRequesterChange(
          prevFlowState.personalDetails,
          prevFlowState.personalDetails.requestingPersonIsTravelingPerson,
          prevFlowState.personalDetails.travellers
        ),
      },
    };
  }
  return updatedFlowState;
};

const resetDateAndLocation: UpdateState = (prevFlowState, key, sliceKey) => {
  if (key === "travelDetails" && sliceKey === "policyType" && prevFlowState.travelDetails.policyType === "annual-trip") {
    //reset end date and location
    return {
      ...prevFlowState,
      travelDetails: {
        ...prevFlowState["travelDetails"],
        endDate: null,
        location: null,
      },
    };
  }
  return prevFlowState;
};

const updateNewTravelPolicyState: UpdateState = (prevFlowState, key, sliceKey, value): NewTravelPolicyState => {
  const path = String(sliceKey).split(".");
  let newFlowState = {
    ...prevFlowState,
    [key]: {
      ...prevFlowState[key],
    },
  };
  // In my ideal vision we can fully rely on callback updates but that needs a bit more work
  newFlowState = set([key, ...path], value, newFlowState);
  newFlowState = resetPlanAndAddOn(newFlowState, key);
  newFlowState = resetAdultAndChildrenCount(newFlowState, key, sliceKey);
  newFlowState = setTravellerType(newFlowState, key, sliceKey);
  newFlowState = setTravellers(newFlowState, key, sliceKey);
  newFlowState = resetDateAndLocation(newFlowState, key, sliceKey);

  return newFlowState;
};

export default updateNewTravelPolicyState;
